<template>
  <div class="table-filter d-flex align-items-start">
    <div class="custom-control custom-control--date">
      <div
        class="custom-control__custom-input d-flex align-items-center justify-content-between"
      >
        <input
          id="date"
          ref="searchInput"
          v-model="date"
          type="text"
          class="w-100"
          :placeholder="this.$t('datum')"
          autofocus
        />
        <div class="atom-icon">
          <img src="@/assets/icons/ico-calendar.svg" />
        </div>
      </div>
      <div
        class="custom-control__selectedValues d-flex align-items-start justify-content-between"
      >
        <div class="custom-control__selectedValues__value">
          <p>
            <span class="gray-text-light">{{ $t("od") }}</span>
            {{ $filters.date(dateFrom) }}
          </p>
          <p>
            <span class="gray-text-light">{{ $t("do") }}</span>
            {{ $filters.date(dateTo) }}
          </p>
        </div>
        <img
          class="custom-control__selectedValues__icon"
          src="@/assets/icons/actions/ico-delete-2.svg"
        />
      </div>
    </div>
    <div class="custom-control custom-control__select">
      <div
        class="custom-control__select__selected"
        :class="{ opened: openedSelect == 1 }"
        @click="toggleOpenSelect(1)"
      >
        <span>{{ $filters.strLimit(type, 12) }}</span>
      </div>
      <div
        class="custom-control__select__options"
        :class="{ opened: openedSelect == 1 }"
      >
        <div class="custom-control__select__option d-flex align-items-center">
          <div class="check">
            <img src="@/assets/icons/check.svg" class="" />
          </div>
          <span class="font-weight-light">{{ type }}</span>
        </div>
      </div>
      <div
        class="custom-control__selectedValues d-flex align-items-start justify-content-between"
      >
        <div class="custom-control__selectedValues__value">
          <p>{{ type }}</p>
        </div>
        <img
          class="custom-control__selectedValues__icon"
          src="@/assets/icons/actions/ico-delete-2.svg"
        />
      </div>
    </div>
    <div class="custom-control custom-control__select">
      <div
        class="custom-control__select__selected"
        :class="{ opened: openedSelect == 2 }"
        @click="toggleOpenSelect(2)"
      >
        <span>{{ $filters.strLimit(user, 12) }}</span>
      </div>
      <div
        class="custom-control__select__options"
        :class="{ opened: openedSelect == 2 }"
      >
        <div class="custom-control__select__option d-flex align-items-center">
          <div class="check">
            <img src="@/assets/icons/check.svg" class="" />
          </div>
          <span class="font-weight-light">{{ user }}</span>
        </div>
      </div>
      <div class="custom-control__selectedValues">
        <div
          class="custom-control__selectedValues__value  d-flex align-items-start justify-content-between"
        >
          <p>{{ user }}</p>
          <img
            class="custom-control__selectedValues__icon"
            src="@/assets/icons/actions/ico-delete-2.svg"
          />
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary d-flex align-items-center justify-content-center"
      @click="filter()"
    >
      <div class="atom-icon">
        <img src="@/assets/icons/actions/ico-search-white.svg" />
      </div>
      {{ $t("hledat") }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    rows: Array
  },
  data() {
    return {
      //show: true,
      dateFrom: "2020-03-12T12:33:23.000Z",
      dateTo: "2020-03-12T12:33:23.000Z",
      type: "Editace zařízení",
      user: "Mirek Dušín",
      openedSelect: 0,
      date: null
      /*slides: [
        {
          "nadpis": "Nadpis",
          "text" : "text",
          "id" : 1
        },
        {
          "nadpis": "Nadpis2",
          "text" : "text2",
          "id" : 2
        }
      ]*/
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      //this.loadSlides();
    },
    slides() {
      //this.setActive();
    }
  },
  mounted() {
    //this.loadSlides();
    //this.setActive();
  },
  methods: {
    filter() {
      let items = [];
      this.$emit("filteredItems", items);
    },
    toggleOpenSelect(value) {
      this.openedSelect = this.openedSelect == value ? 0 : value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
